const FIRST_TOUCH_KEY = "sheepguardian_first_touch";
const LATEST_TOUCH_KEY = "sheepguardian_latest_touch";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function readStorage(key) {
  if (!isBrowser()) return null;

  try {
    const value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  if (!isBrowser()) return;

  try {
    window.localStorage?.setItem(key, JSON.stringify(value));
  } catch {
    // Attribution should never block form submissions.
  }
}

function getCurrentMetadata() {
  if (!isBrowser()) return null;

  const { location, navigator } = window;
  const params = new URLSearchParams(location.search);
  const utm = UTM_KEYS.reduce((values, key) => {
    values[key] = params.get(key) || "";
    return values;
  }, {});

  return {
    currentUrl: location.href,
    hostname: location.hostname,
    pathname: location.pathname,
    routePath: location.hash?.replace(/^#/, "") || location.pathname,
    referrer: document.referrer || "",
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    utm_term: utm.utm_term,
    utm_content: utm.utm_content,
    browserLanguage: navigator.language || "",
    userAgent: navigator.userAgent || "",
    timestamp: new Date().toISOString(),
  };
}

export function getAttributionMetadata() {
  const submissionPage = getCurrentMetadata();
  if (!submissionPage) {
    return {
      firstTouch: null,
      latestTouch: null,
      submissionPage: null,
      submittedAt: new Date().toISOString(),
    };
  }

  let firstTouch = readStorage(FIRST_TOUCH_KEY);
  if (!firstTouch) {
    firstTouch = submissionPage;
    writeStorage(FIRST_TOUCH_KEY, firstTouch);
  }

  writeStorage(LATEST_TOUCH_KEY, submissionPage);

  return {
    ...submissionPage,
    firstTouch,
    latestTouch: submissionPage,
    submissionPage,
    submittedAt: new Date().toISOString(),
  };
}

export function trackEvent(eventName, params = {}) {
  if (!isBrowser() || typeof window.gtag !== "function") return;

  window.gtag("event", eventName, params);

  if (process.env.NODE_ENV === "development") {
    console.info("[analytics]", eventName, params);
  }
}

function getLeadEventParams(formName, leadType, formData = {}) {
  const attribution = getAttributionMetadata();

  return {
    form_name: formName,
    ...(leadType ? { lead_type: leadType } : {}),
    ...(formData.flockSize ? { flock_size: formData.flockSize } : {}),
    source_domain: attribution.hostname || "",
    source_path: attribution.routePath || attribution.pathname || "",
    utm_source: attribution.utm_source || "",
    utm_medium: attribution.utm_medium || "",
    utm_campaign: attribution.utm_campaign || "",
  };
}

export function trackWaitlistSubmit(formData = {}) {
  const params = getLeadEventParams(
    "early_adopter_waitlist",
    "waitlist",
    formData
  );

  trackEvent("generate_lead", params);
  trackEvent("join_waitlist", params);
}

export function trackContactSubmit(formData = {}) {
  const params = getLeadEventParams("contact", null, formData);

  trackEvent("contact_form_submit", params);
}
